import { useNavigate } from 'react-router-dom';
import { Eye, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useRole } from '@/hooks/useRole';
import type { ViewAsRole } from '@/hooks/useViewAs';
import { useViewAs } from '@/hooks/useViewAs';

const LABELS: Record<ViewAsRole, string> = {
  dealer: 'Dealer',
  rep: 'Sales Rep',
  account_manager: 'Account Manager',
};

/**
 * Persistent banner shown while an admin is previewing another role's UI.
 * Client-side preview only — database permissions are unchanged.
 */
const ViewAsBanner = () => {
  const navigate = useNavigate();
  const { realIsAdmin, viewAs } = useRole();
  const { setViewAs } = useViewAs();

  if (!realIsAdmin || !viewAs) return null;

  return (
    <div className="sticky top-0 z-[60] flex items-center justify-center gap-3 bg-amber-500/95 px-4 py-2 text-[13px] font-medium text-amber-950 shadow-sm backdrop-blur">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="truncate">
        Viewing as <strong>{LABELS[viewAs]}</strong> — preview only, your admin access is unchanged.
      </span>
      <Button
        size="sm"
        variant="secondary"
        className="h-7 gap-1 rounded-full px-3 text-xs"
        onClick={() => {
          setViewAs(null);
          navigate('/admin');
        }}
      >
        <X className="h-3 w-3" /> Exit
      </Button>
    </div>
  );
};

export default ViewAsBanner;
